import { render, staticRenderFns } from "./quicklyRegister.vue?vue&type=template&id=50c13b3b&"
import script from "./quicklyRegister.vue?vue&type=script&lang=js&"
export * from "./quicklyRegister.vue?vue&type=script&lang=js&"
import style0 from "./quicklyRegister.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports